@if (repData().length > 0) {
  <app-tabs>
    @for (item of repData(); track item.date) {
      <app-rep-evaluation-tab
        [name]="item.date"
        [repData]="item"
      ></app-rep-evaluation-tab>
    }
  </app-tabs>
}
